import { DisplayAssetType, JourneyAssetName } from './assetLoader'
import { ThemeName } from 'styles/theme'

export interface JourneyAssetItem {
  type: DisplayAssetType
  width: number
  height: number
}

type JourneyAssetDimensions = Record<JourneyAssetName, JourneyAssetItem>

export const JOURNEY_ASSET_DIMENSIONS: Record<
  ThemeName,
  JourneyAssetDimensions
> = {
  googieSilverline: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 450,
    },
    'For-the-Control-v6': {
      type: 'video',
      width: 800,
      height: 536,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 530,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 800,
      height: 534,
    },
    'For-the-Ride-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'image',
      width: 533,
      height: 800,
    },
    'Icon-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'video',
      width: 530,
      height: 800,
    },
  },
  indigoHavana: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 446,
    },
    'For-the-Control-v6': {
      type: 'image',
      width: 800,
      height: 533,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'video',
      width: 800,
      height: 536,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 533,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'image',
      width: 800,
      height: 533,
    },
    'For-the-Ride-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'image',
      width: 533,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 450,
      height: 800,
    },
  },
  mistiPinku: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 452,
    },
    'For-the-Control-v6': {
      type: 'image',
      width: 800,
      height: 533,
    },
    'For-the-Eye-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'video',
      width: 800,
      height: 532,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 532,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 800,
      height: 532,
    },
    'For-the-Ride-v5': {
      type: 'video',
      width: 530,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'image',
      width: 533,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 533,
      height: 800,
    },
  },
  bushBerryville: {
    'Animation-v6': {
      type: 'video',
      width: 532,
      height: 800,
    },
    'For-the-Control-v6': {
      type: 'video',
      width: 800,
      height: 536,
    },
    'For-the-Eye-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'video',
      width: 800,
      height: 448,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 540,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'image',
      width: 800,
      height: 441,
    },
    'For-the-Ride-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 532,
      height: 800,
    },
  },
  reddRumble: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 446,
    },
    'For-the-Control-v6': {
      type: 'video',
      width: 800,
      height: 450,
    },
    'For-the-Eye-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'video',
      width: 800,
      height: 454,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 800,
      height: 454,
    },
    'For-the-Ride-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'image',
      width: 533,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 535,
      height: 800,
    },
  },
  peachesCopperwire: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 450,
    },
    'For-the-Control-v6': {
      type: 'video',
      width: 540,
      height: 800,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'image',
      width: 800,
      height: 532,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'image',
      width: 800,
      height: 533,
    },
    'For-the-Ride-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 449,
      height: 800,
    },
  },
  goldieSamba: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 448,
    },
    'For-the-Control-v6': {
      type: 'image',
      width: 800,
      height: 548,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'image',
      width: 800,
      height: 548,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 528,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 800,
      height: 534,
    },
    'For-the-Ride-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'video',
      width: 528,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 452,
      height: 800,
    },
  },
  fetischeNoir: {
    'Animation-v6': {
      type: 'video',
      width: 800,
      height: 536,
    },
    'For-the-Control-v6': {
      type: 'image',
      width: 800,
      height: 532,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 800,
      height: 800,
    },
    'For-the-Feeling-v6': {
      type: 'image',
      width: 800,
      height: 534,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 800,
      height: 536,
    },
    'For-the-Ride-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'video',
      width: 534,
      height: 800,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 451,
      height: 800,
    },
  },
  default: {
    'Animation-v6': {
      type: 'video',
      width: 768,
      height: 510,
    },
    'For-the-Control-v6': {
      type: 'image',
      width: 800,
      height: 541,
    },
    'For-the-Eye-v5': {
      type: 'video',
      width: 760,
      height: 760,
    },
    'For-the-Feeling-v6': {
      type: 'image',
      width: 800,
      height: 541,
    },
    'For-the-Flow-v7': {
      type: 'video',
      width: 512,
      height: 768,
    },
    'For-the-Pure-v6': {
      type: 'video',
      width: 768,
      height: 510,
    },
    'For-the-Ride-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'For-the-Taste-v6': {
      type: 'video',
      width: 510,
      height: 768,
    },
    'Icon-v5': {
      type: 'image',
      width: 800,
      height: 800,
    },
    'Pattern-v5': {
      type: 'image',
      width: 459,
      height: 800,
    },
  },
}
